import { Checkups, Partners } from '@home-diy-toolbox/web/common-types/refresh-base';
import { CheckupResultBase } from '../../types';
import { findResultPage } from '../../utility';

export const calculateSpeedResults = async (): Promise<CheckupResultBase> => {
	return {
		pageId: await findResultPage(Checkups.SPEED, null, Partners.DEFAULT),
	};
};
